import React, { Component } from 'react'
import { connect } from 'react-redux'
import FuelCredit from './FuelCredit'
import PropTypes from 'prop-types'
import { actions } from '../Services/FuelCredit'

const errorTitle = 'Não foi possível concluir o sua transação.'
const errorDescription =
  'Vamos tentar novamente, por favor verifique os campos baixo.'

class FuelCreditContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isloading: true,
      loadingPayment: false,
      shellSupplierId: 117,
      errorPage: {
        title: errorTitle,
        description: props.descriptionErrorFuelCredit || errorDescription,
        hasError: props.sendRedemptionError
      },
      error: null,
      successPage: null,
      errorField: null,
      acceptTerms: false,
      packageSelected: props.packageSelected || {},
      isValid: null,
      regulationType: 'Vendor',
      showModal: false
    }
    this.handlerChangePackage(this.state.packageSelected)
  }
  componentDidMount () {
    if (!this.props.packages || this.props.packages.length < 1) {
      this.props.loadPackagesBySupplierId(
        this.state.shellSupplierId,
        this.props.clientId
      )
    }
  }

  handlerChangePackage = packageSelected => {
    this.setState({ packageSelected, isValid: null })
  }

  acceptTermsEvent = checked => {
    this.setState({
      showModal: false,
      acceptTerms: checked
    })
  }

  showTermsEvent = () => {
    this.setState({
      showModal: true
    })
  }

  closeterms = () => {
    this.setState({ showModal: false })
  }

  handlerFinalizePayment = () => {
    if (
      this.props.participantBalance < this.state.packageSelected.pointsQuantity
    ) {
      return this.handlerShowErrorPage(
        'Não foi possível concluir o sua transação.',
        'Seu saldo é insuficiente.',
        true
      )
    }

    const orderFuelCredit = {
      totalMiles: this.state.packageSelected.milesQuantity,
      totalPoints: this.state.packageSelected.pointsQuantity,
      transferKey: 'cpf',
      loyaltyNumber: this.props.participant.cpf.value,
      cpf: this.props.participant.cpf.value,
      participantName: this.props.participant.name.value,
      offline: false,
      orderItems: [
        {
          quantity: 1,
          points: this.state.packageSelected.pointsQuantity,
          miles: this.state.packageSelected.milesQuantity,
          totalPoints: this.state.packageSelected.pointsQuantity,
          packageName: this.state.packageSelected.title,
          clientProductCode: this.state.packageSelected.clientProductCode,
          pointsAdjustment: this.state.packageSelected.pointsAdjustment,
          partnerCampaignPackageId: this.state.packageSelected
            .partnerCampaignPackageId
        }
      ],
      orderTypeId: 1
    }

    this.props.redemptionFuelCredit(orderFuelCredit, this.state)
  }

  handleCloseError = () => {
    this.setState({ errorPage: { ...this.state.errorPage, hasError: false } })
    this.props.closeError()
  }

  handlerCloseSuccess = () => {
    this.setState({ successPage: null })
  }

  handlerShowErrorPage = (title, description, hasError) => {
    this.setState({
      errorPage: {
        title: title,
        description: description,
        hasError: hasError,
        closeError: () => this.handleCloseError()
      }
    })
  }

  handlerFormatValue = (value, decimalPlaces) => {
    return value.toLocaleString('pt-br', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    })
  }

  render () {
    const errorPage = {
      title: errorTitle,
      description:
        this.state.description ||
        this.props.descriptionErrorFuelCredit ||
        errorDescription,
      hasError: this.props.sendRedemptionError || this.state.hasError,
      closeError: () => this.handleCloseError()
    }

    return (
      <FuelCredit
        {...this.state}
        errorPage={errorPage}
        packages={this.props.packages}
        handlerFinalizePayment={this.handlerFinalizePayment}
        handleCloseError={this.handleCloseError}
        acceptTermsEvent={this.acceptTermsEvent}
        closeterms={this.closeterms}
        showTermsEvent={this.showTermsEvent}
        packageSelected={this.state.packageSelected}
        handlerChangePackage={this.handlerChangePackage}
        currencyConfiguration={this.props.currencyConfiguration}
        shellSupplierId={this.state.shellSupplierId}
        regulationType={this.state.regulationType}
        acceptTerms={this.state.acceptTerms}
        showModal={this.state.showModal}
        handlerFormatValue={this.handlerFormatValue}
        loadingPayment={this.state.loadingPayment}
        sendRedemptionError={this.props.sendRedemptionError}
        sendRedemption={this.props.sendRedemption}
      />
    )
  }
}

const mapStateToProps = ({
  fuelCredit,
  catalog: { currencyConfiguration },
  participant,
  balance: { pointsValue: participantBalance },
  oidc
}) => {
  const { user } = oidc
  const { profile } = user || {}
  return {
    ...fuelCredit,
    currencyConfiguration,
    participant,
    participantBalance,
    clientId: profile && profile['custom:client_id']
  }
}

const mapDispatchToProps = dispatch => ({
  loadPackagesBySupplierId: (shellSupplierId, clientId) =>
    dispatch(actions.loadPackagesBySupplierId(shellSupplierId, clientId)),
  redemptionFuelCredit: (order, supplierId) =>
    dispatch(actions.redemptionFuelCredit(order, supplierId)),
  closeError: () => dispatch(actions.closeError())
})

const packageType = PropTypes.shape({
  description: PropTypes.string.isRequired,
  partnerId: PropTypes.number.isRequired
})

FuelCreditContainer.propTypes = {
  packages: PropTypes.arrayOf(packageType).isRequired,
  isLoading: PropTypes.bool.isRequired,
  loadPackagesBySupplierId: PropTypes.func.isRequired,
  currencyConfiguration: PropTypes.object,
  participant: PropTypes.object,
  redemptionFuelCredit: PropTypes.func.isRequired,
  sendRedemptionError: PropTypes.bool,
  sendRedemption: PropTypes.bool,
  packageSelected: PropTypes.object,
  closeError: PropTypes.func,
  participantBalance: PropTypes.number,
  descriptionErrorFuelCredit: PropTypes.string,
  clientId: PropTypes.string
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FuelCreditContainer)



// WEBPACK FOOTER //
// ./src/features/FuelCredit/FuelCreditContainer.js